import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

// 路由懒加载 - 提高性能
import Home from '../components/Home.vue'
const ProductDetail = () =>
    import ('../components/ProductDetail.vue')
const AdminLogin = () =>
    import ('../components/AdminLogin.vue')
const AdminDashboard = () =>
    import ('../components/AdminDashboard.vue')
const NewsSection = () =>
    import ('../components/NewsSection.vue')
const NewsDetail = () =>
    import ('../components/NewsDetail.vue')

const routes = [{
        path: '/',
        name: 'Home',
        component: Home,
        meta: { title: '首页' }
    },
    {
        path: '/product/:id',
        name: 'ProductDetail',
        component: ProductDetail,
        props: true,
        meta: { title: '产品详情' }
    },
    {
        path: '/news',
        name: 'NewsList',
        component: NewsSection,
        meta: { title: '新闻资讯' }
    },
    {
        path: '/news/:id',
        name: 'NewsDetail',
        component: NewsDetail,
        props: true,
        meta: { title: '新闻详情' }
    },
    // 管理后台路由
    {
        path: '/admin/login',
        name: 'AdminLogin',
        component: AdminLogin,
        meta: { title: '管理员登录' }
    },
    {
        path: '/admin/dashboard',
        name: 'AdminDashboard',
        component: AdminDashboard,
        meta: { title: '内容管理', requiresAuth: true }
    },
    // 404页面兜底
    {
        path: '*',
        redirect: '/'
    }
]

const router = new VueRouter({
    mode: 'history', // 使用HTML5 History模式（URL更美观）
    routes,

    // 滚动行为控制
    scrollBehavior(to, from, savedPosition) {
        if (savedPosition) {
            return savedPosition // 返回保存的滚动位置
        } else if (to.hash) {
            return { selector: to.hash } // 锚点滚动
        } else {
            return { x: 0, y: 0 } // 滚动到顶部
        }
    }
})

// 路由守卫 - 权限控制和页面标题
router.beforeEach((to, from, next) => {
    document.title = to.meta.title || '产品展示台'

    // 检查是否需要认证
    if (to.meta.requiresAuth) {
        const token = localStorage.getItem('adminToken')
        if (!token) {
            next({
                path: '/admin/login',
                query: { redirect: to.fullPath }
            })
        } else {
            next()
        }
    } else {
        next()
    }
})

export default router